<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/branch">Filiais</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Nova filial</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="save">
                            <div class="row mt-3">
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">CPF / CNPJ*</label>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xx.xxx.xxx/xxxx-xx"
                                            v-model="branch.document"
                                            v-mask="['###.###.###-##', '##.###.###/####-##']">
                                    </div>
                                </div>
                                <div class="col-xl-8 col-md-8 col-sm-12">
                                    <label for="">Nome*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Empresa x LTDA"
                                        v-model="branch.name">
                                </div>
                            </div>
                            <div class="row mb-4">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText @update-text="updateObservation" :modelValue="branch.observation"
                                        placeholderSend="Sem observações"></editorText>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>
                                    <router-link to="/branch" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';

export default {
    directives: { mask },
    components: { Loading, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            url_api: '',
            branch: {
                document: '',
                name: '',
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.branch.document != '' && this.branch.name != '';
        }
    },
    mounted() {
        this.isLoading = false;
        this.url_api = process.env.VUE_APP_URL_API

    },
    methods: {
        onCancel() { },
        updateObservation(observation) {
            this.branch.observation = observation;
        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/branch', this.branch)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Filial cadastrada com sucesso!",
                        type: 'success'
                    });
                    this.branch = {};
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })
        }
    }
}
</script>

<style lang="scss" scoped></style>